import { safeFetch } from "../utils/safeFetch";
import { buildApiError } from "../utils/apiErrors";


// Ottieni tutti gli utenti
export const getAllUtenti = async (token, tenant) => {
    const response = await safeFetch(`/api/users`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    }, 'allUsers');

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const getMyUserProfile = async (token, tenant) => {
    const response = await fetch('/api/users/me/permissions', {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        },
        cache: 'no-store'
    });

    if (!response.ok) throw await buildApiError(response, `HTTP error! status: ${response.status}`);
    return await response.json();
};

// Ottieni utenti per ruolo
export const getUtentiByRole = async (roleName, token, tenant) => {
    const response = await safeFetch(`/api/users/by-role/${roleName}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    }, 'utentiByRole');

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

// Aggiunta di un utente
export const registerUtente = async (userData, tenant) => {
    const response = await safeFetch(`/api/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            'x-tenant-id': tenant
        },
        body: JSON.stringify(userData),
    }, 'registerUtente');

    if (!response.ok) {
        throw await buildApiError(response, 'Errore nella registrazione utente');
    }
    return await response.json();
};

// Aggiorna un utente
export const updateUtente = async (id, data, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    }, 'updateUtente');

    if (!response.ok) throw await buildApiError(response, `HTTP error! status: ${response.status}`);
    return await response.json();
};

export const setUtenteActive = async (id, isActive, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}/status`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ isActive }),
    }, `setUtenteActive:${id}`);

    if (!response.ok) throw await buildApiError(response, `HTTP error! status: ${response.status}`);
    return await response.json();
};

// Elimina un utente
export const deleteUtente = async (id, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    }, 'deleteUtente');

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

// Aggiorna password utente
export const patchPasswordUtente = async (id, newPassword, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}/password`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: newPassword })
    }, 'patchPasswordUtente');

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

// Aggiorna preferenze utente
export const patchPreferenzeUtente = async (id, preferences, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}/preferences`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(preferences)
    }, 'patchPreferenzeUtente');

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const getAllPermissions = async (token, tenant) => {
    const response = await safeFetch(`/api/permissions`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    }, 'allPermissions');

    if (!response.ok) throw await buildApiError(response, `HTTP error! status: ${response.status}`);
    return await response.json();
};

export const getUserPermissions = async (id, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}/permissions`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    }, `userPermissions:${id}`);

    if (!response.ok) throw await buildApiError(response, `HTTP error! status: ${response.status}`);
    return await response.json();
};

export const updateUserPermissions = async (id, permissionIds, token, tenant) => {
    const response = await safeFetch(`/api/users/${id}/permissions`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ permissionIds })
    }, `updateUserPermissions:${id}`);

    if (!response.ok) throw await buildApiError(response, `HTTP error! status: ${response.status}`);
    return await response.json();
};
